import { createSelector } from 'reselect';
import { compose, every, filter, get, map } from 'lodash/fp';

import mapSelectionToPositions from '../utils/mapSelectionToPositions';

function normalizeData(lineup) {
  return {
    entryCount: lineup.entryCount,
    favorite: lineup.favorite,
    name: get('slate.name', lineup),
    id: lineup.id,
    selection: mapSelectionToPositions(lineup.selection),
    selectionHash: lineup.selectionHash,
    sportIcon: lineup.sportIcon,
    unsubmitted: lineup.entryCount === 0
  };
}

function getLineUps(lineups, lineupTypeFilters) {
  return compose(
    filter(lineup => every(x => lineup[x], lineupTypeFilters)),
    map(normalizeData)
  )(lineups);
}

const loadableLineupsSelector = createSelector(
  get('myTeams.lineups'),
  get('myTeams.lineupTypeFilters'),
  getLineUps
);

export default loadableLineupsSelector;
